import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize16 {
  size: '16';
}
interface OverrideIconSize20 {
  size?: '20';
}
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize16 | OverrideIconSize20 | OverrideIconSize24;

const SvgComponent = ({
  size = '20',
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '16') {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8.5 2V10.5" stroke={color} strokeLinecap="round" />
        <path
          d="M5.5 8L8.14645 10.6464C8.34171 10.8417 8.65829 10.8417 8.85355 10.6464L11.5 8"
          stroke={color}
          strokeLinecap="round"
        />
        <path
          d="M3 10V13C3 13.2761 3.22386 13.5 3.5 13.5H13.5C13.7761 13.5 14 13.2761 14 13V10"
          stroke={color}
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (size === '20') {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.64638 12.8536C9.84164 13.0488 10.1582 13.0488 10.3535 12.8536L13.1819 10.0251C13.3772 9.82986 13.3772 9.51328 13.1819 9.31802C12.9867 9.12276 12.6701 9.12276 12.4748 9.31802L10.4999 11.2929L10.4999 3.5C10.4999 3.22386 10.2761 3 9.99993 3C9.72379 3 9.49993 3.22386 9.49993 3.5L9.49993 11.2929L7.52506 9.31802C7.3298 9.12276 7.01322 9.12276 6.81796 9.31802C6.62269 9.51328 6.62269 9.82986 6.81796 10.0251L9.64638 12.8536Z"
          fill={color}
        />
        <path
          d="M3.5 10.5V15.5C3.5 16.0523 3.94772 16.5 4.5 16.5H15.5C16.0523 16.5 16.5 16.0523 16.5 15.5V10.5"
          stroke={color}
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5 3.5C12.5 3.22386 12.2761 3 12 3C11.7239 3 11.5 3.22386 11.5 3.5L11.4994 15.0376L8.11091 11.6464L8.04167 11.5886C7.8468 11.4536 7.57737 11.4729 7.40381 11.6464C7.20854 11.8417 7.20854 12.1583 7.40381 12.3536L11.6779 16.625L11.733 16.6655L11.8279 16.7122L11.8946 16.7315C11.9286 16.7388 11.9638 16.7426 12 16.7426L12.0742 16.7372L12.1277 16.7261L12.1943 16.7035L12.2707 16.6631C12.3001 16.6442 12.3279 16.6219 12.3536 16.5962L16.5962 12.3536L16.654 12.2843C16.789 12.0894 16.7698 11.82 16.5962 11.6464L16.5269 11.5886C16.3321 11.4536 16.0627 11.4729 15.8891 11.6464L12.4994 15.0376L12.5 3.5ZM20.9919 14.4101C20.9496 14.1769 20.7455 14 20.5 14C20.2239 14 20 14.2239 20 14.5V19.5L19.9919 19.5899C19.9496 19.8231 19.7455 20 19.5 20H4.5L4.41012 19.9919C4.17688 19.9496 4 19.7455 4 19.5V14.5L3.99194 14.4101C3.94961 14.1769 3.74546 14 3.5 14C3.22386 14 3 14.2239 3 14.5V19.5L3.00687 19.6445C3.07955 20.4051 3.7203 21 4.5 21H19.5L19.6445 20.9931C20.4051 20.9204 21 20.2797 21 19.5V14.5L20.9919 14.4101Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 16, 20, 24 입니다.
 *
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'download');
export default IconComponent;
